import type { Asset } from '@ztechapps/common.contract'
import { InlineInput } from '@ztechapps/webui.input'
import { useAssetPageContext } from '../Context'

type AssetFieldInputProps = {
  item: Asset
  field: 'title' | 'subtitle'
  label?: string
}

export const AssetFieldInput = ({ item, field, label }: AssetFieldInputProps) => {
  const { onUpdateAsset } = useAssetPageContext()

  // Use child resolver mutation for individual asset update
  const handleUpdate = async ({ input }: { input: Record<string, unknown> }) => {
    if (item._id) {
      // Use the updateAsset mutation which triggers AssetChildRepository.preSave
      await onUpdateAsset(item._id, { [field]: input[field] })
    }
    return {}
  }

  return <InlineInput initialValues={item} label={label} name={field} onUpdate={handleUpdate} />
}

type AssetDetailsProps = {
  item: Asset
}

export const AssetDetails = ({ item }: AssetDetailsProps) => {
  return (
    <>
      <AssetFieldInput item={item} field="title" label="Title" />
      <AssetFieldInput item={item} field="subtitle" label="Subtitle" />
    </>
  )
}
